// Import chart strategies
import { AreaChartStrategy } from 'features/charts-v2/strategies/Area'
import { BarChartStrategy } from 'features/charts-v2/strategies/Bar'
import { BubbleChartStrategy } from 'features/charts-v2/strategies/Bubble'
import { HeatmapChartStrategy } from 'features/charts-v2/strategies/Heatmap'
import { HistogramChartStrategy } from 'features/charts-v2/strategies/Histogram'
import { HorizontalBarChartStrategy } from 'features/charts-v2/strategies/HorizontalBar'
import { LineChartStrategy } from 'features/charts-v2/strategies/Line'
import { PercentAreaChartStrategy } from 'features/charts-v2/strategies/PercentArea'
import { PieChartStrategy } from 'features/charts-v2/strategies/Pie'
import { RidgelineChartStrategy } from 'features/charts-v2/strategies/Ridgeline'
import { SankeyChartStrategy } from 'features/charts-v2/strategies/Sankey'
import { ScatterChartStrategy } from 'features/charts-v2/strategies/Scatter'
import { StackedAreaChartStrategy } from 'features/charts-v2/strategies/StackedArea'
import { StackedBarChartStrategy } from 'features/charts-v2/strategies/StackedBar'
import { SummaryMetricsChartStrategy } from 'features/charts-v2/strategies/SummaryMetrics'
import { TreemapChartStrategy } from 'features/charts-v2/strategies/Treemap'
import { ChartStrategy } from 'features/charts-v2/types/chart-strategy'
import { ChartTypeV2 } from 'features/charts-v2/types/chart-types'

export class ChartFactory {
  private static instance: ChartFactory
  private strategies: Map<ChartTypeV2, ChartStrategy> = new Map()

  private constructor() {
    this.registerDefaultStrategies()
  }

  public static getInstance(): ChartFactory {
    if (!ChartFactory.instance) {
      ChartFactory.instance = new ChartFactory()
    }
    return ChartFactory.instance
  }

  private registerDefaultStrategies(): void {
    // Register all available chart strategies
    this.register(new BarChartStrategy())
    this.register(new HorizontalBarChartStrategy())
    this.register(new LineChartStrategy())
    this.register(new AreaChartStrategy())
    this.register(new BubbleChartStrategy())
    this.register(new PieChartStrategy())
    this.register(new TreemapChartStrategy())
    this.register(new SummaryMetricsChartStrategy())

    // Recently implemented strategies
    this.register(new StackedBarChartStrategy())
    this.register(new StackedAreaChartStrategy())
    this.register(new PercentAreaChartStrategy())
    this.register(new ScatterChartStrategy())
    this.register(new HistogramChartStrategy())
    this.register(new HeatmapChartStrategy())
    this.register(new RidgelineChartStrategy())
    this.register(new SankeyChartStrategy())
  }

  public register(strategy: ChartStrategy): void {
    this.strategies.set(strategy.chartType, strategy)
  }

  public getStrategy(chartType: ChartTypeV2): ChartStrategy | null {
    return this.strategies.get(chartType) || null
  }

  public getAllStrategies(): ChartStrategy[] {
    return Array.from(this.strategies.values())
  }

  public getSupportedChartTypes(): ChartTypeV2[] {
    return Array.from(this.strategies.keys())
  }

  public hasStrategy(chartType: ChartTypeV2): boolean {
    return this.strategies.has(chartType)
  }

  public unregister(chartType: ChartTypeV2): boolean {
    return this.strategies.delete(chartType)
  }

  public clear(): void {
    this.strategies.clear()
  }
}

export const chartFactory = ChartFactory.getInstance()
